var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.default_class},[_c('q-checkbox',{attrs:{"id":`${_vm.grid}-grid-checkbox`},on:{"input":_vm.inputCheckbox},model:{value:(_vm.checkbox_select),callback:function ($$v) {_vm.checkbox_select=$$v},expression:"checkbox_select"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }